import cameraSystem from '../../assets/part-types/camera-system.jpg';
import powerbox from '../../assets/part-types/powerbox.jpg';
import siteController from '../../assets/part-types/site-controller.jpg';
import unitController from '../../assets/part-types/unit-controller.jpg';
import waterQualitySensor from '../../assets/part-types/water-quality-sensor.jpg';
import winchSystem from '../../assets/part-types/winch-system.jpg';

/**
 * A photo of each part type for the line picker. Gen 1 and Gen 2 look the
 * same, so there is one per type; types without one show the empty slot.
 */
const partTypePhotos: Partial<Record<string, string>> = {
  CAMERA_SYSTEM: cameraSystem,
  POWERBOX: powerbox,
  SITE_CONTROLLER: siteController,
  UNIT_CONTROLLER: unitController,
  WATER_QUALITY_SENSOR: waterQualitySensor,
  WINCH_SYSTEM: winchSystem,
};

export function partTypePhoto(type: string): string | undefined {
  return partTypePhotos[type];
}
